import { useMutation } from 'react-query';
import { BASE_API_URL } from '@env';
import axios from 'axios';
import { useUserStore } from '~providers/userStore/zustand';

export interface FlexibleReviewPayload {
  event_id: number;
  metadata: Record<string, any>;
  user_id: string;
  event_type: string;
}

export const useFlexibleReview = () => {
  const { mutate, isLoading } = useMutation(async (payload: FlexibleReviewPayload) => {
    const token = useUserStore.getState().token;
    const response = await axios.post(
      `${BASE_API_URL}events/review/flexible`,
      payload,
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization: token,
        },
      },
    );
    
    if (!response.data) {
      throw new Error('Failed to submit flexible review');
    }

    const data = await response.data;
    console.log(data, 'flexible review data');

    return data as any;
  });

  return {
    submitFlexibleReview: mutate,
    isLoading,
  };
};